import axios from "axios";
import { corsBypass, REACT_APP_BASE_URL_METIS } from "../constants/enviroments";
import { interceptorHelper } from "./interceptor";
import { handleAxiosError } from "./Axios";

const baseUrl = `${REACT_APP_BASE_URL_METIS}`;

let CohortsAxios = axios.create({
  baseURL: `${
    process.env.NODE_ENV === "development" ? corsBypass : ""
  }${baseUrl}`,
});

CohortsAxios.interceptors.request.use(
  interceptorHelper.config,
  interceptorHelper.error
);

CohortsAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    return handleAxiosError(error);
  }
);

export async function DeleteCohort(id, isDraft) {
  return CohortsAxios.delete(
    isDraft ? `/cohorts/drafts/${id}` : `/cohorts/${id}`
  );
}

export async function UpdateCohort(data, id) {
  return CohortsAxios.patch(`/cohorts/${id}`, data);
}

export async function CreateNewCohort(data) {
  return CohortsAxios.post(`/cohorts`, data);
}

export async function SaveCohortAsDraft(data) {
  return CohortsAxios.post(`/cohorts/draft`, data);
}

export async function UpdateCohortAsDraft(data, id) {
  return CohortsAxios.put(`/cohorts/drafts/${id}`, data);
}

export async function JoinCohort(data) {
  return CohortsAxios.post(`/cohorts/cart`, data);
}

export async function PayForCohort(data) {
  return CohortsAxios.post(`/cohorts/apply`, data);
}

export async function GetMentorCohorts(username) {
  return CohortsAxios.get(`/cohorts/mentors/${username}`);
}

export async function GetCohortDetails(slug) {
  return CohortsAxios.get(`/cohorts/slug/${slug}`);
}

export async function GetMyCohorts() {
  return CohortsAxios.get(`/users/me/cohorts`);
}
export async function GetMyCreatedCohorts() {
  return CohortsAxios.get(`/cohorts`);
}

export const GetDraftCohorts = () => {
  return CohortsAxios.get(`/cohorts/users/draft`);
};

export async function GetCohortAttendees(id) {
  return CohortsAxios.get(`/cohorts/${id}/attendees`);
}

export async function GetCohortMessages(id) {
  return CohortsAxios.get(`/cohorts/${id}/messages`);
}

export async function SendCohortAnnouncement(data) {
  return CohortsAxios.post(`/cohorts/message`, data);
}

export async function StartMeetingRecording(data) {
  return CohortsAxios.post(`/call/start-recording`, data);
}

export async function StopMeetingRecording(data) {
  return CohortsAxios.post(`/call/stop-recording`, data);
}

export async function GetMeetingRecordings(id) {
  return CohortsAxios.get(`/call/recordings/${id}`);
}

export async function GetRecordingDetails(id) {
  return CohortsAxios.get(`/call/recording/${id}`);
}
